import {createVehicle,stepVehicle,selectGear,restart} from './vehicle.js';
export const DISTANCES=[1000,2000,3000];
export const STEP=1/120;
export const PERFECT_WINDOW=.150;
export class Race {
  constructor(){this.reset(1000);}
  reset(distance=this.length){
    this.length=DISTANCES.includes(distance)?distance:1000;
    this.vehicle=createVehicle();this.previous={...this.vehicle};this.phase='ready';
    this.elapsed=0;this.countdown=3;this.accumulator=0;this.launchTime=0;
    this.launched=false;this.reactionTime=null;this.perfectLaunch=false;this.failure=null;
    this.result=null;this.paused=false;this.assisted=false;this.events=[];
  }
  // Called by the first clutch press, never by a timer or an on-screen start button.
  start(){const assisted=this.assisted;this.reset(this.length);this.assisted=assisted;this.vehicle.clutch=1;this.phase='countdown';this.emit('armed');}
  emit(type){this.events.push(type);}
  shift(gear){
    if(this.paused)return;
    if(this.phase==='countdown'||(this.phase==='racing'&&!this.launched)){this.emit('launchLocked');return;}
    if(this.phase!=='racing')return;
    const event=selectGear(this.vehicle,gear);if(event)this.emit(event);
  }
  clutch(value){
    if(this.paused)return;
    const pressed=value>=.95;
    if(this.phase==='ready'){this.vehicle.clutch=pressed?1:0;if(pressed)this.start();return;}
    if(this.phase==='countdown'){
      if(!pressed){this.phase='failed';this.failure='falseStart';this.vehicle.clutch=1;this.emit('falseStart');}
      return;
    }
    if(this.phase!=='racing')return;
    this.vehicle.clutch=pressed?1:0;
    if(!this.launched&&!pressed){
      this.launched=true;this.reactionTime=this.elapsed+this.accumulator;
      this.perfectLaunch=this.reactionTime<=PERFECT_WINDOW+1e-8;
      this.emit(this.perfectLaunch?'perfectLaunch':'launch');
    }
  }
  ignite(){if(!this.paused&&this.phase==='racing'&&this.launched&&restart(this.vehicle))this.emit('restart');}
  pause(){if(['countdown','racing','braking'].includes(this.phase)&&!this.paused){this.paused=true;this.assisted=true;this.vehicle.clutch=1;this.emit('pause');}}
  resume(){
    if(!this.paused)return;
    // Lost touches before takeoff require a fresh hold, never an accidental release/launch.
    if(!this.launched){this.reset(this.length);this.assisted=true;}else this.paused=false;
  }
  tick(seconds){if(this.paused)return;this.accumulator+=Math.max(0,Math.min(seconds,.25));while(this.accumulator+1e-10>=STEP){this.step(STEP);this.accumulator-=STEP;}}
  step(dt){
    if(!['countdown','racing','braking','failed'].includes(this.phase))return;
    this.previous={...this.vehicle};
    const v=this.vehicle,oldDistance=v.distance,oldTime=this.elapsed,stalled=v.stalled;
    if(this.phase==='countdown'){
      v.clutch=1;stepVehicle(v,dt,{revving:true});this.countdown=Math.max(0,this.countdown-dt);
      if(this.countdown<=1e-8){this.countdown=0;this.phase='racing';this.emit('go');}
      return;
    }
    if(this.phase==='racing'){
      if(!this.launched)v.clutch=1;
      else this.launchTime+=dt;
      stepVehicle(v,dt,{revving:!this.launched});this.elapsed+=dt;
      if(!stalled&&v.stalled)this.emit('stall');
      if(v.broken){this.phase='failed';this.failure='damage';this.emit('damage');}
      else if(v.distance>=this.length){const fraction=(this.length-oldDistance)/(v.distance-oldDistance);this.result=oldTime+dt*fraction;this.elapsed=this.result;this.phase='braking';this.emit('finish');}
    }else{
      v.clutch=1;stepVehicle(v,dt,{braking:true});
      if(v.speed<.05&&this.phase==='braking'){v.speed=0;this.phase='finished';}
    }
  }
  renderState(){const alpha=Math.max(0,Math.min(1,this.accumulator/STEP)),vehicle={...this.vehicle};if(['countdown','racing','braking'].includes(this.phase))for(const key of ['distance','speed','rpm'])vehicle[key]=this.previous[key]+(vehicle[key]-this.previous[key])*alpha;return {vehicle,length:this.length};}
  drainEvents(){return this.events.splice(0);}
}
// Scoring now starts at the green light and includes reaction time; keep old rules' data intact.
export const RECORD_KEY='shift-race-records-v2';
export function readRecords(storage){try{const raw=storage.read(RECORD_KEY);const data=typeof raw==='string'?JSON.parse(raw):raw;const valid={};for(const d of DISTANCES)if(Number.isFinite(data?.[d])&&data[d]>0)valid[d]=data[d];return valid;}catch{return {};}}
export function saveRecord(storage,records,race){if(race.assisted||!Number.isFinite(race.result)||race.result<=0)return false;const old=records[race.length];if(old&&old<=race.result)return false;try{const next={...records,[race.length]:race.result};storage.write(RECORD_KEY,JSON.stringify(next));Object.assign(records,next);return true;}catch{return false;}}
